import { useFormContext } from 'react-hook-form';

export interface HookFormProps
  extends Omit<
    React.DetailedHTMLProps<
      React.FormHTMLAttributes<HTMLFormElement>,
      HTMLFormElement
    >,
    'onSubmit'
  > {
  onSubmit: (value: any) => Promise<void> | void;
  noDefaultClass?: boolean;
}
export const HookForm = (props: HookFormProps) => {
  const {
    children,
    onSubmit,
    className = '',
    noDefaultClass = false,
    ...rest
  } = props;
  const { handleSubmit } = useFormContext();

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      {...rest}
      className={`${
        !noDefaultClass ? 'bg-white relative w-full h-full' : ''
      } ${className}`}
    >
      {children}
    </form>
  );
};
